module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "pro"
    }
  }), _vm._v("PROLOGUE")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The blast took her face off. Two seconds of pressure on the trigger and a full shotgun load went roaring out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We’d been doing good. In with a maximum of ferocity. Get ’em terrorised, shouting ‘Get the fuck down – "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NOW")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Push push push.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let ’em see the guns, hear the manic screaming of very dangerous men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doc had planted devices at the")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("cop shop")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tesco")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Masonic Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("They’d gone off like lubrication. You had the noise, smoke, confusion and then we’re in – ‘MENACE’ writ brutal large.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh yeah, fuckin’ A.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bingo, the motherload. More cash than Camelot, two bin-liners overflowing with readies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everything hunky-dory…. and then …")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then I shot the cashier in the face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I guess it began with Cassie.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018286a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 72
// module chunks = 0